import { render, staticRenderFns } from "./categoryDummy.vue?vue&type=template&id=78c07716&scoped=true"
import script from "./categoryDummy.vue?vue&type=script&lang=js"
export * from "./categoryDummy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c07716",
  null
  
)

export default component.exports